"use strict";

exports.__esModule = true;
var _exportNames = {
  documentRef: true,
  windowRef: true,
  EventListener: true,
  useEventListener: true
};
exports.useEventListener = exports.EventListener = exports.windowRef = exports.documentRef = void 0;

var _EventListener = require("./EventListener");

exports.EventListener = _EventListener.EventListener;

var _types = require("./types");

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  exports[key] = _types[key];
});

var _useEventListener = require("./useEventListener");

exports.useEventListener = _useEventListener.useEventListener;
var documentRef = {
  current: typeof document === 'undefined' ? null : document
};
exports.documentRef = documentRef;
var windowRef = {
  current: typeof window === 'undefined' ? null : window
};
exports.windowRef = windowRef;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@fluentui/react-component-event-listener/dist/commonjs/index.js
// module id = 709
// module chunks = 0